import React, { useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { Button } from '@ferris/react/components/button';
import { TrackingContext } from '@vrbo/react-event-tracking';
import { createImpressionEvent, createInteractionEvent } from '../../../../utils/EventProviders/EgClickstreamUtil';

const EmailIsVerifiedAlready = ({
    title, text, reason, cta, pageFlow
}) => {
    const { trigger } = useContext(TrackingContext);

    useEffect(() => {
        trigger('impression', createImpressionEvent('email_verified_error.presented', 'is_email_verified', reason, '2.3.0'));
    }, []);

    const onClick = () => {
        trigger('interaction', createInteractionEvent('next_button.initiated', 'is_email_verified', 'ContinueOnboarding', '', '2.4.0'));
        pageFlow.next();
    };

    return (
        <section className={cn('email-verified-section')}>
            <div className={cn('email-verified-content')}>
                <h1>{title}</h1>
                <p>{text}</p>
                <Button
                    id="email-verified-btn"
                    onClick={onClick}
                >
                    {cta}
                </Button>
            </div>
        </section>
    );
};

EmailIsVerifiedAlready.propTypes = {
    reason: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
    cta: PropTypes.string.isRequired,
    pageFlow: PropTypes.shape({
        next: PropTypes.func
    }).isRequired
};

export default EmailIsVerifiedAlready;
